import { HttpHandler } from 'msw'

import { getAllDisputes } from './getAllDisputes'

export const disputes: HttpHandler[] = [getAllDisputes]
